import { render, staticRenderFns } from "./CreateVehicle.vue?vue&type=template&id=4dd5c363&scoped=true"
import script from "./CreateVehicle.vue?vue&type=script&lang=ts"
export * from "./CreateVehicle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd5c363",
  null
  
)

export default component.exports